/* eslint-disable no-unused-expressions */
import React, { useEffect, useState } from 'react'
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow
} from '@material-ui/core'
import { AccessAlarm, CheckCircleOutlineOutlined, HighlightOff, StarsRounded } from '@material-ui/icons'
import { dinamicTablesStyles } from "./styles"

const PartnersTable = ({ info }) => {
  const [filteredArray, setFilteredArray] = useState(info)
  const [quizzState, setQuizzState] = useState('todas')
  const [selectedBtn, setSelectedBtn] = useState('todas')
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(5)
  const [count, setCount] = useState(info)
  const classes = dinamicTablesStyles()

  const filterArray = (type, key) => {
    const quizzesSelected = type === 'quizz' ? key : quizzState
    const actionsSelected = type === 'action' ? key : selectedBtn
    const newArrayQuizzes = quizzesSelected !== 'todas' ? info.filter(el => el.estado === quizzesSelected) : info
    const newArrayActions = actionsSelected !== 'todas' ? newArrayQuizzes.filter(el => el[actionsSelected] > 0) : newArrayQuizzes
    setFilteredArray(newArrayActions)
    setCount(newArrayActions)
    if (type === 'action') {
      setSelectedBtn(key)
    }
    setPage(0)
  };

  const handleChange = (type, e) => {
    setQuizzState(e.target.value);
    filterArray(type, e.target.value)
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const updateValues = () => {
    setFilteredArray(info)
    setQuizzState('todas')
    setSelectedBtn('todas')
    setCount(info)
  }
  useEffect(() => {
    updateValues()
  }, [info])
  return (
    <Box className={classes.container} >
      <h3 className={classes.title}>Socio</h3>
      <Box className={classes.containerQuizzesFilters}>
        <FormControl>
          <InputLabel id='select-partner' style={{color: '#5A5A5A'}}>Estado de la encuesta</InputLabel>
          <Select
            labelId='select-partner'
            value={quizzState}
            className={classes.select}
            onChange={e => handleChange('quizz', e)}
          >
            <MenuItem value='todas'>Todas las encuestas</MenuItem>
            <MenuItem value='Consolidado'>Consolidado</MenuItem>
            <MenuItem value='Conciliar'>Conciliar</MenuItem>
            <MenuItem value='Evaluar Socio'>Evaluar socio</MenuItem>
            <MenuItem value='Pend evaluación socio'>Pend evaluación socio</MenuItem>
            <MenuItem value='Sin evaluación'>Sin evaluación</MenuItem>
          </Select>
        </FormControl>
        <Box>
          <Button
            className={selectedBtn === 'todas' ? classes.btnSelected : classes.btnFilter}
            onClick={() => filterArray('action','todas')}
          >
            Todas las acciones
          </Button>
          <Button
            className={selectedBtn === 'totalAcciones' ? classes.btnSelected : classes.btnFilter}
            onClick={() => filterArray( 'action', 'totalAcciones')}
            startIcon={<StarsRounded style={{ color:'#F5CD26'}} />}
          >
            Total
          </Button>
          <Button
            className={selectedBtn === 'accionesCompletadas' ? classes.btnSelected : classes.btnFilter}
            onClick={() => filterArray('action', 'accionesCompletadas')}
            startIcon={<CheckCircleOutlineOutlined style={{ color: '#65BA0F' }} />}
          >
            Completas
          </Button>
          <Button
            className={selectedBtn === 'accionesPendientes' ? classes.btnSelected : classes.btnFilter}
            onClick={() => filterArray('action', 'accionesPendientes')}
            startIcon={<AccessAlarm style={{ color: '#2699FB' }} />}
          >
            Pendientes
          </Button>
          <Button
            className={selectedBtn === 'accionesVencidas' ? classes.btnSelected : classes.btnFilter}
            onClick={() => filterArray('action', 'accionesVencidas')}
            startIcon={<HighlightOff style={{ color: '#BA330F' }} />}
          >
            Vencidas
          </Button>
      </Box>
      </Box>
      <TableContainer className={classes.tableContainer}>
        <Table>
          <TableHead className={classes.head}>
            <TableRow className={classes.rowHead}>
              <TableCell>Socio</TableCell>
              <TableCell>Jefe</TableCell>
              <TableCell>Estado encuesta</TableCell>
              <TableCell>Total acciones</TableCell>
              <TableCell>Acciones completas</TableCell>
              <TableCell>Acciones pendientes</TableCell>
              <TableCell>Acciones vencidas</TableCell>
            </TableRow>
          </TableHead>
          <TableBody className={classes.body}>
            {filteredArray?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(partner => (
              <TableRow key={partner.socio}>
                <TableCell style={{color: '#2699FB'}}>{partner.socio}</TableCell>
                <TableCell >{partner.jefe}</TableCell>
                <TableCell>{partner.estado}</TableCell>
                <TableCell className={classes.centeredCell}>{partner.totalAcciones}</TableCell>
                <TableCell className={classes.centeredCell}>{partner.accionesCompletadas}</TableCell>
                <TableCell className={classes.centeredCell}>{partner.accionesPendientes}</TableCell>
                <TableCell className={classes.centeredCell}>{partner.accionesVencidas}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={count.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Box>
  )
}

export default PartnersTable